<template>
  <b-container id="app" class="h-100 intranet" :class="{ notAuth: !isAuthenticated }">
    <Header></Header>
    <Sidebar v-if="isAuthenticated"/>
    <router-view class="content" :class="isLoading ? 'modal-open':''" />
    <Footer></Footer>
    <div class="loader"
      v-if="isLoading"
      :visible="isLoading"
      centered
      :hide-footer="true"
      :hide-header="true"
      :hide-header-close="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <div class="precarga">
        <b-spinner class="mx-2"></b-spinner>
        Cargando información...
      </div>
    </div>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Sidebar from "./components/Sidebar.vue";
import auth from "@/store/authentication.js";
import Header from "./components/Header";
import Footer from "./components/Footer";
import axios from "axios";
export default {
  name: "App",
  components: {
    Footer,
    Header,
    Sidebar,
  },
  created() {
    if (typeof auto_login !== 'undefined' && auto_login) {
      let params = {
        access_token: customer_token,
        refresh_token: "",
      };
      localStorage.setItem("user_role", "customer");
      localStorage.setItem("user", customer_email);

      this.$store.dispatch("authentication/authenticateCustomer", params)
      axios.defaults.headers.common.Authorization = 'Bearer ' + customer_token;
      //location.reload();

      if(localStorage.getItem('reloaded') == null) {
        localStorage.setItem('reloaded', 1);
        location.reload();
      }
    }
    this.isAuthenticated = auth.state.authenticated;
  },
  data() {
    return {
      "isAuthenticated": null
    }
  },
  computed: {
    isLoading: {
      get: function () {
        return (
          this.$store.getters["admin/isLoading"] ||
          this.$store.getters["customer/isLoading"] ||
          this.$store.getters["event/isLoading"] ||
          this.$store.getters["material/isLoading"] ||
          this.$store.getters["new/isLoading"] ||
          this.$store.getters["partner/isLoading"] ||
          this.$store.getters["project/isLoading"] ||
          this.$store.getters["provider/isLoading"] ||
          this.$store.getters["order/isLoading"] ||
          this.$store.getters["ticket/isLoading"] ||
          this.$store.getters["pack/isLoading"] ||
          this.$store.getters["proposal/isLoading"]
        );
      },
      set: function () {
      },
    },
  },
};
</script>

<style lang="scss">
  #app.intranet{
    // Import custom SASS variable overrides, or alternatively
    // define your variable overrides here instead
    @import "sass/_variables.scss";

    // Import Bootstrap and BootstrapVue source SCSS files
    @import "~bootstrap/scss/bootstrap.scss";
    @import "~bootstrap-vue/src/index.scss";

    $fa-font-path: "~@fortawesome/fontawesome-free-webfonts/webfonts";
    @import "~@fortawesome/fontawesome-free-webfonts/scss/fontawesome.scss";
    @import "~@fortawesome/fontawesome-free-webfonts/scss/fa-solid.scss";
    @import "~@fortawesome/fontawesome-free-webfonts/scss/fa-regular.scss";
    @import "~@fortawesome/fontawesome-free-webfonts/scss/fa-brands.scss";

    @import 'node_modules/@livelybone/vue-datepicker/lib/css/index.scss';

    #mainRow {
      width: 100%;
    }
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/App.vue